import { IDbBook } from "../../../types/database/IDbBook";
import { IDbFolder } from "../../../types/database/IDbFolder";

import {
  REQUEST_LIBRARY,
  SET_ACTIVE_FOLDER,
  SET_ACTIVE_RECORD,
  SUBSCRIBE_TO_FOLDER,
  SUBSCRIBE_TO_FOLDER_ERROR,
  SUBSCRIBE_TO_FOLDER_SUCCESS,
  SUBSCRIBE_TO_RECORD,
  SUBSCRIBE_TO_RECORD_ERROR,
  SUBSCRIBE_TO_RECORD_SUCCESS,
} from "./constants";
import {
  RequestLibrary,
  SetActiveFolder,
  SetActiveRecord,
  SubscribeToFolder,
  SubscribeToFolderError,
  SubscribeToFolderSuccess,
  SubscribeToRecord,
  SubscribeToRecordError,
  SubscribeToRecordSuccess,
} from "./actionTypes";

export function requestLibrary(): RequestLibrary {
  return ({
    type: REQUEST_LIBRARY,
  });
}

export function setActiveFolder(folderId: string | undefined): SetActiveFolder {
  return ({
    type: SET_ACTIVE_FOLDER,
    payload: folderId,
  });
}

export function setActiveRecord(recordId: string | undefined): SetActiveRecord {
  return ({
    type: SET_ACTIVE_RECORD,
    payload: recordId,
  });
}

export function subscribeToFolder(): SubscribeToFolder {
  return ({
    type: SUBSCRIBE_TO_FOLDER,
  });
}

export function subscribeToFolderError(folderId: string): SubscribeToFolderError {
  return ({
    type: SUBSCRIBE_TO_FOLDER_ERROR,
    payload: folderId,
  });
}

export function subscribeToFolderSuccess(folderId: string, folder: IDbFolder): SubscribeToFolderSuccess {
  return ({
    type: SUBSCRIBE_TO_FOLDER_SUCCESS,
    payload: {
      folderId,
      folder,
    },
  });
}

export function subscribeToRecord(): SubscribeToRecord {
  return ({
    type: SUBSCRIBE_TO_RECORD,
  });
}

export function subscribeToRecordError(recordId: string): SubscribeToRecordError {
  return ({
    type: SUBSCRIBE_TO_RECORD_ERROR,
    payload: recordId,
  });
}

export function subscribeToRecordSuccess(recordId: string, book: IDbBook): SubscribeToRecordSuccess {
  return ({
    type: SUBSCRIBE_TO_RECORD_SUCCESS,
    payload: {
      recordId,
      book,
    },
  });
}
